





































































































import type { PropType } from '@nuxtjs/composition-api';
// eslint-disable-next-line no-duplicate-imports
import { computed, defineComponent } from '@nuxtjs/composition-api';

import { useLink } from '~/diptyqueTheme/composable/useLink';
import { useScreenSize } from '~/diptyqueTheme/composable/useScreenSize';
import type { MediaPreloadableSection } from '~/diptyqueTheme/types/components';
import type { CommitmentPushModel } from '~/integrations/contentful/src/types';

export default defineComponent({
  name: 'CommitmentPush',
  components: {
    VaimoSlider: () => import('molecules/VaimoSlider.vue'),
    VaimoBanner: () => import('atoms/VaimoBanner.vue'),
    VaimoHeading: () => import('atoms/VaimoHeading.vue'),
    VaimoButton: () => import('atoms/VaimoButton.vue'),
    DesktopOneItem: () => import('./parts/DesktopOneItem.vue'),
    MobileOneItem: () => import('./parts/MobileOneItem.vue'),
    Labels: () => import('./parts/Labels.vue')
  },
  props: {
    sectionData: {
      required: true,
      type: Object as PropType<CommitmentPushModel & MediaPreloadableSection>
    }
  },
  setup(props) {
    const getItems = computed(
      () => props.sectionData.itemsCollection?.items || []
    );
    const isOneItem = computed(() => getItems.value.length === 1);
    const { normalizeLink } = useLink();
    const { isDesktop } = useScreenSize();

    return {
      getItems,
      isDesktop,
      isOneItem,
      normalizeLink
    };
  }
});
